import { render, staticRenderFns } from "./SettingsClientDropdown.vue?vue&type=template&id=b733f998&scoped=true&lang=pug&"
import script from "./SettingsClientDropdown.vue?vue&type=script&lang=js&"
export * from "./SettingsClientDropdown.vue?vue&type=script&lang=js&"
import style0 from "./SettingsClientDropdown.vue?vue&type=style&index=0&id=b733f998&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b733f998",
  null
  
)

export default component.exports